/* Brand assets */
export const LOGO_URL = "/x10-logo.png";

export const OFFICE_MOCKUP_URL =
  "https://customer-assets.emergentagent.com/job_ai-optimize-9/artifacts/ynr6d6jz_B19DA375-5B93-4439-A5E6-57063786977C.png";

export const X10_GOLD = "#C9A96E";
